import CookiesJS from 'cookies-js';

export function initPractices($, apiClient) {
    function extractArrayItems(field) {
        const items = [];
        $(`#${field} .array-item .array-item-value`).each(function () {
            items.push($(this).val());
        });
        return items;
    }

    $('form.practice-form .action__entity-save').on('click', async function () {
        try {
            const _id = $(this).attr('data-object-id');
            const images = [];
            $('#images .upload-images__image-container').each(function () {
                images.push($(this).attr('data-key'));
            });
            const practice = {
                title: $('#title').val(),
                description: $('#description').val(),
                steps: extractArrayItems('steps'),
                images,
                time: $('#time').val(),
                videoUrl: $('#videoUrl').val(),
                equipment: extractArrayItems('equipment'),
                tags: extractArrayItems('tags'),
                deleted: !!$('#deleted').prop('checked'),
            };
            if (!_id) {
                const result = await apiClient.create('/practices', practice, CookiesJS.get('auth_token'));
                console.log(result);
                document.location.href=`/practices/edit/${result._id}`;
            } else {
                const result = await apiClient.updateOne('/practices', _id, practice, CookiesJS.get('auth_token'));
                console.log(result);
                alert('Сохранено');
                location.reload();
            }
        } catch (e) {
            console.warn(e);
            if (e.response
                && e.response.data
                && e.response.data.errors
                && e.response.data.errors[0]
                && e.response.data.errors[0].msg
            ) {
                alert(`${e.response.data.errors[0].msg}: ${e.response.data.errors[0].param}`);
            } else {
                alert(e);
            }
        }
    });
}
